import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class PaginationItem extends Component {
  handleClick = () => {
    const { onClick, value } = this.props;
    if (onClick) {
      onClick(value);
    }
  };

  render() {
    const { isActive, isDisabled, children, onClick, value } = this.props;
    const itemClassName = classNames({
      active: isActive,
      disabled: isDisabled,
    });
    let anchorProps = {};

    if (!isDisabled && onClick) {
      anchorProps = {
        onClick: this.handleClick,
        href: '#',
      };
    }

    return (
      <li className={itemClassName}>
        <a {...anchorProps}>{children || value}</a>
      </li>
    );
  }
}

PaginationItem.defaultProps = {
  value: undefined,
  onClick: null,
  isActive: false,
  isDisabled: false,
};

PaginationItem.propTypes = {
  value: PropTypes.any,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default PaginationItem;
